// Request schemas
export {
  AppointmentCreatedBy,
  BookedAppointmentsReadPurpose,
  IntakeType,
  voiceCallOutcomeSchema,
  createPatientRequestSchema,
  createPatientFromIntakeRequestSchema,
  intakeCoverageSchema,
  searchOpenAppointmentsRequestSchema,
  searchPatientsRequestSchema,
  appointmentSlotSchema as bookAppointmentSlotSchema,
  bookAppointmentRequestSchema,
  cancelAppointmentRequestSchema,
  getBookedAppointmentsRequestSchema,
  rescheduleAppointmentRequestSchema,
  getCurrentAppointmentActionId,
  getAllAppointmentTypesRequestSchema,
  getTopInsurancePackagesRequestSchema,
  createPatientInsuranceRequestSchema,
  getLatestReferralRequestSchema,
  appointmentStatusSchema,
  availabilityAppointmentTypeSchema,
  getAvailabilityRequestSchema,
  getLocationsRequestSchema,
  checkEligibilityRequestSchema,
  relevantSchedulingRulesRequestSchema,
  relevantSchedulingRulesResponseSchema,
  createTelephoneEncounterRequestSchema,
  createTelephoneEncounterResponseSchema,
  ingestTranscriptPayloadSchema,
  stallMetricEntrySchema,
  experimentTagSchema,
  toolErrorTypeSchema,
  toolCallErrorSchema,
  sessionReportSchema,
  dateFormatSchema,
  getProviderNamesResponseSchema,
  getClinicFaqResponseSchema,
  getPatientNamesByPhoneRequestSchema,
  getPatientNamesByPhoneResponseSchema,
  submitVoiceCsatPayloadSchema,
} from "@/shared/agent-api/requests";
export {
  appointmentActionIdSchema,
  normalizedEhrIdSchema,
  versionedAppointmentActionIdSchema,
} from "@/shared/common-schemas";
export {
  ChatItemRole,
  ChatItemType,
  conversationItemAddedEventSchema,
  EventType,
  functionToolsExecutedEventSchema,
  rawSessionChatItemSchema,
  sessionEventSchema,
  sessionEventsSchema,
  speechCreatedEventSchema,
} from "@/shared/agent-api/session-events";
export type { RawSessionChatItem, SessionEvent } from "@/shared/agent-api/session-events";

export type {
  SearchOpenAppointmentsRequest,
  SearchPatientsRequest,
  BookAppointmentSlot,
  BookAppointmentRequest,
  CancelAppointmentRequest,
  CreatePatientFromIntakeRequest,
  GetBookedAppointmentsRequest,
  AvailabilityAppointmentType,
  ScheduleAvailability,
  GetAvailabilityRequest,
  GetLocationsRequest,
  IntakeCoverage,
  RescheduleAppointmentRequest,
  CheckEligibilityRequest,
  RelevantSchedulingRulesRequest,
  RelevantSchedulingRulesResponse,
  CreateTelephoneEncounterRequest,
  CreateTelephoneEncounterResponse,
  IngestTranscriptPayload,
  StallMetricEntry,
  ExperimentTag,
  ToolErrorType,
  ToolCallError,
  VoiceCallOutcome,
  SessionReport,
  GetProviderNamesResponse,
  GetClinicFaqResponse,
  GetPatientNamesByPhoneRequest,
  GetPatientNamesByPhoneResponse,
  SubmitVoiceCsatPayload,
} from "@/shared/agent-api/requests";
export {
  isLivekitTracedHttpRoute,
  LIVEKIT_ENDPOINT_ROOT_SPAN_NAME,
  LIVEKIT_ENDPOINT_SPAN_ID_ATTRIBUTE,
  LIVEKIT_ENDPOINT_TRACE_ID_ATTRIBUTE,
  LIVEKIT_SESSION_MARKER_SPAN_NAME,
  LIVEKIT_SESSION_SPAN_ID_ATTRIBUTE,
  LIVEKIT_SESSION_TRACE_ID_ATTRIBUTE,
  LIVEKIT_TRACE_STATE_KEY,
  LIVEKIT_TRACE_STATE_VALUE,
} from "@/shared/agent-api/trace-routes";
export {
  AgentResponseKind,
  RESPONSE_LATENCY_ATTRIBUTE,
  RESPONSE_LATENCY_SPAN_NAME,
  ResponseClassificationSource,
  ResponseLatencyAgentRuntime,
  responseLatencySpanAttributesSchema,
} from "@/shared/agent-api/response-latency";
export type { ResponseLatencySpanAttributes } from "@/shared/agent-api/response-latency";

export {
  agentCoverageSchema,
  agentPatientSchema,
  patientNotFoundResponseSchema,
  PatientMatchMethod,
  RecommendationType,
  searchPatientsResponseSchema,
} from "@/shared/agent-api/responses";

export type {
  SearchPatientsResponse,
  SearchOpenAppointmentsResponse,
  BookAppointmentResponse,
  CancelAppointmentResponse,
  BookedAppointment,
  CreatePatientFromIntakeResponse,
  GetBookedAppointmentsResponse,
  AvailabilityResponse,
  GetLocationsResponse,
  Location as AgentLocation,
  AvailabilityAppointmentSlot,
  Coverage,
  RescheduleAppointmentResponse,
  EligibilityProviderResult,
  EligibilityLocationResult,
  AgenticEligibilityResponse,
  RankedAppointment,
  RankingNoRecommendationsReason,
  AgenticRankedAppointmentsResponse,
  CheckEligibilityResponse,
} from "@/shared/agent-api/responses";

export {
  schedulingBookAppointmentToolSchema,
  schedulingBookedAppointmentsDateRangeToolSchema,
  schedulingConfirmAppointmentToolSchema,
  schedulingRetrievePatientDemographicsToolSchema,
  schedulingOpenAppointmentLookupToolParamsSchema,
  schedulingOpenAppointmentLookupWindowToolSchema,
  schedulingPatientLookupToolSchema,
  schedulingRescheduleBySlotIdsToolSchema,
} from "@/shared/agent-api/scheduling-tool-schemas";
